const axios = require('axios');
const config = require('../../config.json')[process.env.NODE_ENV]
var api = axios.create({
  baseURL: config.backend_url
});

module.exports = api;